export default __webpack_public_path__ + "static/media/ava-2.fcb8d844.png";